import Product from './Product';
function ProductsSection() {
  return (
    <div className='container mt-5'>
          <div className='row  justify-content-center text-center pt-3'>
            <div className='col-12 col-md-8 col-lg-9 landing_h3 text-center mb-4' id="productos">Productos</div>
          </div>
          <div className='container me-lg-0 my-5 ms-lg-auto'>
            <div className='row justify-content-lg-end align-items-center'>
              <div className='col-xl-6 col-lg-6 col-md-6 col-12'>
                <Product 
                  title='Papel aluminio'
                  image='reynolds-papel-aluminio'
                  text='Producto de aluminio versátil que proporciona resistencia y durabilidad superiores. ¡Es ideal para envolver, cocinar, hornear, asar, cubrir y más!'
                />
              </div>
              <div className='col-xl-6 col-lg-6 col-md-6 col-12'>
                <Product 
                  title='Plástico adherente'
                  image='reynolds-plastico-adherente'
                  text='Con este film transparente, los restos de comida, como frutas y verduras, se pueden envolver herméticamente, alargando su vida útil y ahorrándote tiempo y dinero. Sella el sabor del interior y retiene el aire y la humedad.'
                />
              </div>
              <div className='col-xl-6 col-lg-6 col-md-6 col-12'>
                <Product 
                  title='Bolsas ultra resistentes'
                  image='reynolds-bolsas'
                  text='Disponibles en cinco tamaños diferentes: SÁNDWICH (PEQUEÑO)| ALMACENAMIENTO MEDIANO Y GRANDE | CONGELADOR MEDIANO Y GRANDE. Todas nuestras bolsas tienen una cremallera resellable duradera que se puede abrir y cerrar muchas veces, y son reutilizables.'
                />
              </div>
              <div className='col-xl-6 col-lg-6 col-md-6 col-12'>
                <Product 
                  title='Papel para hornear y cocinar'
                  image='reynolds-papel-hornear'
                  text='Papel multiusos que se puede utilizar para una variedad de actividades de cocina y horneado. Antiadherente de doble cara: lo que significa que el papel no se pega a la bandeja ni a los alimentos, y se puede utilizar de diversas formas, para cocinar, almacenar o empacar almuerzos.'
                />
              </div>
            </div>
          </div>
        </div>
  );
}

export default ProductsSection;
